import { TRACE_HEADER } from '@calm/web-common/dist/tracing';
import { RumEvent, RumEventDomainContext } from '@datadog/browser-rum-slim';

export default function beforeSend(
    event: RumEvent,
    context: RumEventDomainContext
) {
    if (
        event.type === 'resource' &&
        event.resource.type === 'xhr' &&
        'response' in context
    ) {
        event.context = {
            ...event.context,
            traceparent:
                context.response?.headers.get(TRACE_HEADER) ??
                'no-tracing-header',
        };
    }
    return true;
}
